@if ($datas(); as datas) {
  <div class="container-config">
    <div class="config-title">Configuration</div>
    <div class="marg-top-fifteen">
      <div class="config-row">
        <div class="config-row-child">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CHART.TYPE' | translate }}</mat-label>
            <mat-select
              [ngModel]="datas.y"
              (ngModelChange)="updateData($event)"
              [style.color]="setColor(datas.y, 1)">
              <mat-option value="mileage">{{ 'CHART.MILEAGE' | translate }}</mat-option>
              <mat-option value="stops">{{ 'CHART.STOPS' | translate }}</mat-option>
              <mat-option value="engine">{{ 'CHART.ENGINE' | translate }}</mat-option>
              <mat-option value="trip_time">{{ 'CHART.TRAVEL_TIME' | translate }}</mat-option>
              <mat-option value="speed_avg">{{ 'CHART.AVERAGE_SPEED' | translate }}</mat-option>
              @if ($account().isSubsEco) {
                <mat-option value="eco_avg">{{ 'CHART.ECO_DRIVING_AVG' | translate }}</mat-option>
              }
              <mat-option value="fuel_consumed">{{ 'CHART.FUEL_CONSUMED' | translate }}</mat-option>
              @if ($account().fuel_option && $account().administrator) {
                <mat-option value="fuel_quantity_100_km">
                  {{ 'CHART.FUEL_QUANTITY_100_KM' | translate }}
                </mat-option>
                <mat-option value="fuel_cost_100_km">{{ 'CHART.FUEL_COST_100_KM' | translate }}</mat-option>
                <mat-option value="CO2_100_km">{{ 'CHART.CO2_100_KM' | translate }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="config-row-child">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'DATE.PERIOD' | translate }}</mat-label>
            <mat-select [ngModel]="datas.period" (ngModelChange)="setPeriod($event)">
              <mat-option value="M3">{{ 'DATE.LAST_THREE_MONTHS' | translate }}</mat-option>
              <mat-option value="ML">{{ 'DATE.LAST_MONTH' | translate }}</mat-option>
              <mat-option value="MR">{{ 'DATE.CURRENT_MONTH' | translate }}</mat-option>
              <mat-option value="WL">{{ 'DATE.LAST_WEEK' | translate }}</mat-option>
              <mat-option value="WR">{{ 'DATE.CURRENT_WEEK' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="config-row-child">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CHART.UNIT' | translate }}</mat-label>
            <mat-select
              [disabled]="datas.y !== 'engine'"
              [ngModel]="unit"
              (ngModelChange)="unit = $event; updateUnit()">
              <mat-option value="h">h</mat-option>
              <mat-option value="%">%</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="config-row">
        <div class="config-row-child">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'CHART.RUPTURE' | translate }}</mat-label>
            <mat-select [ngModel]="datas.group" (ngModelChange)="updateGroup($event)">
              <mat-option value="device">{{ 'CHART.SENSOR' | translate }}</mat-option>
              <mat-option value="service">{{ 'CHART.SERVICE' | translate }}</mat-option>
              <mat-option value="month">{{ 'DATE.MONTH' | translate }}</mat-option>
              <mat-option value="week">{{ 'DATE.WEEK' | translate }}</mat-option>
              <mat-option value="day">{{ 'DATE.DAY' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="config-row-child">
          <div style="width: 100%">
            <span class="label-select-service">{{ 'CHART.SERVICE' | translate }}</span>
            @if (!!$unitsById()) {
              <div (click)="selectService()" class="select-services-config">
                <p style="padding: 5px">
                  {{
                    $unitsById()?.[datas?.uid_service]
                      ? $unitsById()[datas.uid_service]?.label
                      : ('CHART.GLOBAL_FLEET' | translate)
                  }}
                </p>

                <mat-icon>
                  {{ changingService ? 'arrow_drop_up' : 'arrow_drop_down' }}
                </mat-icon>
              </div>
            }
            @if (changingService) {
              <div class="chart-select-service">
                <tree
                  (selectedCheckbox)="changeService($safeNavigationMigration($event[0]?.uid))"
                  [displaySelected]="false"
                  [closable]="false"
                  [selected]="[datas.uid_service]"
                  [element]="'service'"
                  selectionType="radio"
                  [elementSelectedType]="'node'"
                  [rootItem]="true"
                  [labelSearch]="'TREE.SEARCH_SERVICE'"
                  [maxHeight]="200"
                  [labelRoot]="'CHART.GLOBAL_FLEET'" />
              </div>
            }
          </div>
          @if (
            cameFromService ||
            (datas.group === 'service' &&
              !!datas.uid_service &&
              !!$unitsById() &&
              $safeNavigationMigration($unitsById()[datas.uid_service]) !== null)
          ) {
            <button
              matMiniFab
              (click)="navigateServiceUp()"
              [matTooltip]="'CHART.PARENT_SERVICE' | translate">
              <mat-icon>publish</mat-icon>
            </button>
          }
        </div>
        <div class="config-row-child">
          <mat-slide-toggle [ngModel]="datas.compare" (ngModelChange)="updateCompare($event)">
            <p class="label-compare">
              {{ 'CHART.COMPARISON' | translate }}
              <span>
                ({{
                  datas.compare ? ('COMMON.ACTIVATEDBIS' | translate) : ('COMMON.DEACTIVATEDBIS' | translate)
                }})
              </span>
            </p>
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
}
